import Logo from '../../../_metronic/assets/everyvisit-logo.svg'
import LogoMc from '../../../_metronic/assets/mc-logo.svg'
import {Fragment, useEffect, useRef, useState} from 'react'
import {useNavigate} from 'react-router-dom'
import {useMerchantData} from '../hook'
import ContactUs from '../components/ContactUs'
import subscribePlan from '../services/subscriptionPlan'
import {toast} from 'react-toastify'
import {useIntl} from 'react-intl'
import {Stepper} from '../components/Stepper'
import ManPNG from '../assets/man.png'
import MAIN from '../../auth/asset/main.jpg'

export default function BecomeAMerchantPricing() {
  const [selectedPackage, setSelectedPackage] = useState<any>(null)
  const [modal, setModal] = useState(false)
  const intl = useIntl()
  const navigate = useNavigate()
  const {merchantData} = useMerchantData()
  const packageRef = useRef(null) as any
  const packageRef2 = useRef(null) as any
  const packageEnterpriceRef = useRef(null) as any
  const packageEnterpriceRef2 = useRef(null) as any
  const [loadingBtn, setLoadingBtn] = useState(false)

  useEffect(() => {
    if (!merchantData?.merchantID || merchantData.merchantID === '') {
      navigate('/')
    }
  }, [merchantData.merchantID, navigate])

  const packages = [
    {
      // packageName: 'Welcome Offer',
      packageName: intl.formatMessage({id: 'AUTH.SUBSCRIPTION.WELCOME_OFFER'}),
      packageID: '778a43b3-d07b-4cbb-b1e9-fc233617dc51',
      price: '',
      discountedPrice: '9.99',
      monthlyOrderLimit: '500',
      monthlyTrxFeePerLylTrx: '$ 0.10',
      pointCouponRedemptionFee: '2.50%',
      loyaltyMembersServed: intl.formatMessage({id: 'AUTH.SUBSCRIPTION.NO_LIMIT'}),
      memberLimit: intl.formatMessage({id: 'AUTH.SUBSCRIPTION.NO_LIMIT'}),
      email: '500',
      sms: '500',
      // customerSupport: 'Live Chat',
      customerSupport: intl.formatMessage({id: 'AUTH.SUBSCRIPTION.Mail'}),
      portalUser: '1',
      multiStore: true,
      vipProgram: true,
      overages: {
        price: 10,
        orders: 250,
      },
      serviceFees: {
        loyaltyTrx: '0.10',
        pointRedemption: '2.50',
        couponUsage: '2.50',
      },
      kickstartCampaigns: true,
      fullControlCampaigns: false,
      embeddedFinance: true,
      eStore: true,
      campaignRecommendations: false,
      productBasedRecommendations: false,
      referralProgram: true,
      deferredPointActivation: false,
      customPointActivation: false,
      analyticPage: true,
      customizableEmailNotifications: false,
      howToVideos: true,
      helpCenter: true,
      sevenDaysSupport: false,
      emailSupport: false,
      chatbotSupport: true,
    },
    {
      // packageName: 'Growth',
      packageName: intl.formatMessage({id: 'AUTH.SUBSCRIPTION.GROWTH'}),
      packageID: '131e688e-e9eb-428a-a9f5-4792eac5e8cf',
      price: '59.00',
      discountedPrice: '49.99',
      monthlyOrderLimit: '2,500',
      monthlyTrxFeePerLylTrx: '$ 0.10',
      pointCouponRedemptionFee: '2.50%',
      loyaltyMembersServed: intl.formatMessage({id: 'AUTH.SUBSCRIPTION.NO_LIMIT'}),
      memberLimit: intl.formatMessage({id: 'AUTH.SUBSCRIPTION.NO_LIMIT'}),
      email: '500',
      sms: '500',
      portalUser: '2',
      // customerSupport: 'Live Chat',
      customerSupport: intl.formatMessage({id: 'AUTH.SUBSCRIPTION.Mail'}),
      multiStore: true,
      vipProgram: true,
      overages: {
        price: 10,
        orders: 250,
      },
      serviceFees: {
        loyaltyTrx: '0.10',
        pointRedemption: '2.00',
        couponUsage: '2.00',
      },
      kickstartCampaigns: true,
      fullControlCampaigns: true,
      embeddedFinance: true,
      eStore: true,
      campaignRecommendations: false,
      productBasedRecommendations: true,
      referralProgram: true,
      deferredPointActivation: false,
      customPointActivation: false,
      analyticPage: true,
      customizableEmailNotifications: true,
      howToVideos: true,
      helpCenter: true,
      sevenDaysSupport: false,
      emailSupport: true,
      chatbotSupport: true,
    },
    {
      // packageName: 'Pro',
      packageName: intl.formatMessage({id: 'AUTH.SUBSCRIPTION.PRO'}),
      packageID: '4c38dc45-f29e-4136-9c73-7761325656f9',
      price: '99.99',
      discountedPrice: '99.99',
      monthlyOrderLimit: '7,500',
      monthlyTrxFeePerLylTrx: '$ 0.10',
      pointCouponRedemptionFee: '2.50%',
      loyaltyMembersServed: intl.formatMessage({id: 'AUTH.SUBSCRIPTION.NO_LIMIT'}),
      memberLimit: intl.formatMessage({id: 'AUTH.SUBSCRIPTION.NO_LIMIT'}),
      email: '500',
      sms: '500',
      portalUser: '3',
      // customerSupport: 'Live Agent & Live Chat',
      customerSupport: '+' + intl.formatMessage({id: 'AUTH.SUBSCRIPTION.Agent'}),
      multiStore: true,
      vipProgram: true,
      overages: {
        price: 10,
        orders: 500,
      },
      serviceFees: {
        loyaltyTrx: '0.10',
        pointRedemption: '2.00',
        couponUsage: '2.00',
      },
      kickstartCampaigns: true,
      fullControlCampaigns: true,
      embeddedFinance: true,
      eStore: true,
      campaignRecommendations: true,
      productBasedRecommendations: true,
      referralProgram: true,
      deferredPointActivation: true,
      customPointActivation: true,
      analyticPage: true,
      customizableEmailNotifications: true,
      howToVideos: true,
      helpCenter: true,
      sevenDaysSupport: true,
      emailSupport: true,
      chatbotSupport: true,
    },
  ]

  const faqs = [
    /*     {
      title: intl.formatMessage({id: 'AUTH.SUBSCRIPTION.FAQ_8'}),
      content: intl.formatMessage({id: 'AUTH.SUBSCRIPTION.FAQ_8_CONTENT'}),
    }, */
    {
      title: intl.formatMessage({id: 'AUTH.SUBSCRIPTION.FAQ_1'}),
      content: intl.formatMessage({id: 'AUTH.SUBSCRIPTION.FAQ_1_CONTENT'}),
    },
    {
      title: intl.formatMessage({id: 'AUTH.SUBSCRIPTION.FAQ_2'}),
      content: intl.formatMessage({id: 'AUTH.SUBSCRIPTION.FAQ_2_CONTENT'}),
    },
    {
      title: intl.formatMessage({id: 'AUTH.SUBSCRIPTION.FAQ_3'}),
      content: intl.formatMessage({id: 'AUTH.SUBSCRIPTION.FAQ_3_CONTENT'}),
    },
    {
      title: intl.formatMessage({id: 'AUTH.SUBSCRIPTION.FAQ_4'}),
      content: intl.formatMessage({id: 'AUTH.SUBSCRIPTION.FAQ_4_CONTENT'}),
    },
    {
      title: intl.formatMessage({id: 'AUTH.SUBSCRIPTION.FAQ_5'}),
      content: intl.formatMessage({id: 'AUTH.SUBSCRIPTION.FAQ_5_CONTENT'}),
    },
    {
      title: intl.formatMessage({id: 'AUTH.SUBSCRIPTION.FAQ_6'}),
      content: intl.formatMessage({id: 'AUTH.SUBSCRIPTION.FAQ_6_CONTENT'}),
    },
    {
      title: intl.formatMessage({id: 'AUTH.SUBSCRIPTION.FAQ_7'}),
      content: intl.formatMessage({id: 'AUTH.SUBSCRIPTION.FAQ_7_CONTENT'}),
    },
    /*     {
      title: intl.formatMessage({id: 'AUTH.SUBSCRIPTION.FAQ_9'}),
      content: intl.formatMessage({id: 'AUTH.SUBSCRIPTION.FAQ_9_CONTENT'}),
    }, */
  ]

  useEffect(() => {
    if (packageRef.current && packageEnterpriceRef.current) {
      const height = Math.max(
        packageRef.current.clientHeight,
        packageEnterpriceRef.current.clientHeight
      )

      packageRef.current.style.height = `${height}px`
      packageEnterpriceRef.current.style.height = `${height}px`
    }

    if (packageRef2.current && packageEnterpriceRef2.current) {
      const height = Math.max(
        packageRef2.current.clientHeight,
        packageEnterpriceRef2.current.clientHeight
      )

      packageRef2.current.style.height = `${height}px`
      packageEnterpriceRef2.current.style.height = `${height}px`
    }
  }, [
    packageRef.current?.clientHeight,
    packageEnterpriceRef2.current?.clientHeight,
    packageEnterpriceRef2,
    packageRef2.current?.clientHeight,
  ])

  const changePackage = (packageID: string) => {
    localStorage.setItem('selectedPackage', packageID)
    setSelectedPackage(packages.find((item) => item.packageID === packageID))
  }

  const getSelectedPackage = () => {
    const packageID = localStorage.getItem('selectedPackage')
    return packages.find((item) => item.packageID === packageID)
  }

  useEffect(() => {
    const selectedPackage = getSelectedPackage()
    if (selectedPackage) {
      setSelectedPackage(selectedPackage)
    }
  }, [])

  return (
    <Fragment>
      <ContactUs modal={modal} setModal={setModal} merchantData={merchantData} />
      <div className='d-flex flex-column flex-root px-10 bg-white' id='kt_app_root'>
        <div className='flex-column flex-column-fluid bg-white' id='kt_app_page'>
          <div className='flex-column-fluid'>
            <div id='' className=''>
              <div className='card '>
                <div
                  className='container-fluid d-flex align-items-stretch justify-content-between pt-8 pb-10 pb-lg-0'
                  id='kt_app_header_container'
                >
                  <div className='app-header-logo d-flex align-items-center ps-lg-2 me-lg-10'>
                    <a href='../sign-in'>
                      <img alt='Logo' src={LogoMc} className='h-25px' />
                      <img alt='Logo' src={Logo} className='h-35px' />
                    </a>
                  </div>

                  <div className='d-flex align-items-stretch justify-content-between flex-lg-grow-1'>
                    <div
                      className='d-flex align-items-stretch'
                      id='kt_app_header_menu_wrapper'
                    ></div>
                  </div>
                </div>

                <Stepper activeStep={2} />

                <div className='card-title px-10 pt-10 pt-lg-20'>
                  <div>
                    <h1 className='text-start p-0 fw-bolder text-primary'>
                      {/* Ready to grow your business? */}
                      {/* {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.READY_TO_GROW'})} */}
                      {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.CHOOSE_YOUR_PLAN'})}
                    </h1>
                    <p className='p-0 fs-3'>
                      {/* Start turning every transaction into an opportunity for deeper customer
                      connections and increased sales. */}
                      {/* {intl.formatMessage({
                        id: 'AUTH.SUBSCRIPTION.START_TURNING_EVERY_TRANSACTION',
                      })} */}
                    </p>
                  </div>
                </div>

                <div className='d-flex flex-row mt-6 align-items-start row px-10'>
                  <div className='col-lg-9'>
                    <div
                      // BB1900 kirmizi
                      // FFB000 turuncu
                      className='d-flex rounded justify-content-between'
                      style={{
                        height: '300px',
                        backgroundColor: 'rgb(241,65,108)',
                        background:
                          'linear-gradient(90deg, rgba(187, 25, 0, 1) 0%, rgba(255, 176, 0, 1) 80%, rgba(255,255,255,1) 100%)',
                      }}
                    >
                      <div
                        className='w-50 p-5 d-flex flex-column align-items-start justify-content-center'
                        style={{
                          paddingLeft: '250px',
                          marginLeft: '75px',
                        }}
                      >
                        <h2
                          className='text-white fw-bolder text-shadow'
                          style={{textShadow: '2px 2px 4px #000', fontSize: '35px'}}
                        >
                          {/* {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.BANNER_TITLE'})}
                           */}
                          {intl.formatMessage({
                            id: 'AUTH.SUBSCRIPTION.START_TURNING_EVERY_TRANSACTION',
                          })}
                        </h2>
                        {/* <h1
                          className='text-white fs-7x fw-bolder'
                          style={{textShadow: '4px 2px 4px #000'}}
                        >
                          {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.BANNER_TITLE_2'})}
                        </h1> */}
                        {/*     <div className='d-flex flex-column'>
                          <span className='text-black fs-1 bg-white rounded-3 px-2 py-1 mb-2'>
                            {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.BANNER_DESC1'})}
                          </span>
                           <span className='text-white fs-3'>
                            {intl.formatMessage({ id: 'AUTH.SUBSCRIPTION.BANNER_DESC2' })}
                          </span>
                           <span className='text-white fs-3'>
                            {intl.formatMessage({ id: 'AUTH.SUBSCRIPTION.BANNER_DESC3' })}
                          </span>
                        </div> */}
                      </div>
                      <div
                        className='d-flex flex-column justify-content-end'
                        style={{width: '300px', height: '300px'}}
                      >
                        <div
                          className='w-100 h-100'
                          style={{
                            backgroundImage: `url(${MAIN})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                            borderRadius: '50%',
                          }}
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className='card-body p-4 pt-7 px-10 w-100'
                  style={{
                    maxWidth: '100%',
                  }}
                >
                  {/* <span className='text-start py-5 fs-2 text-primary'> */}
                  {/* Choose your plan and get started with EveryVisit today. */}
                  {/* {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.CHOOSE_YOUR_PLAN'})}
                  </span> */}
                  <div className='row mt-6' id='pricingCol'>
                    {packages.map((item, index) => {
                      return (
                        <div className='col-3' ref={packageRef} key={index}>
                          <div className='d-flex min-w-400px align-items-center'>
                            <div
                              className={`w-100 d-flex flex-column flex-center rounded-3 py-15 px-10 position-relative`}
                              style={{
                                backgroundColor: 'rgb(231 231 231)',
                                // active
                                border:
                                  selectedPackage?.packageID === item.packageID
                                    ? '2px solid #FFB000'
                                    : 'none',
                              }}
                            >
                              {/* active package top center ACTIVE */}
                              {selectedPackage?.packageID === item.packageID && (
                                <div className='position-absolute top-0 start-50 translate-middle'>
                                  <span
                                    style={{
                                      backgroundColor: '#FFB000',
                                      padding: '5px 10px',
                                      borderRadius: '5px',
                                    }}
                                  >
                                    ACTIVE
                                  </span>
                                </div>
                              )}
                              <div className='mb-7 text-center'>
                                <h1 className={`mb-5 fw-bolder`}>{item.packageName}</h1>

                                <div className='text-center' style={{color: '#141413'}}>
                                  <span className='mb-2'>$</span>
                                  <span className='fs-3x fw-bold'>{item.discountedPrice}</span>
                                  <span className='fs-7 fw-semibold'>
                                    /{intl.formatMessage({id: 'GLOBAL.MONTHLY'})}
                                  </span>
                                </div>
                                {/*
                                <div className='text-center'>
                                  <span className='mb-2'>$</span>

                                  <span
                                    // text underline
                                    className=' fw-bold '
                                    style={{fontSize: '21px'}}
                                    data-kt-plan-price-month='39'
                                    data-kt-plan-price-annual='399'
                                  >
                                    {item.discountedPrice}{' '}
                                  </span>

                                  <span className='fs-7 fw-semibold'>
                                    /
                                    <span data-kt-element='period'>
                                      {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.MON'})}
                                    </span>
                                  </span>
                                </div> */}
                              </div>

                              <div className='w-100 mb-10'>
                                <div className='fw-bold fs-5 fst-italic'>LOYALTY FEATURES</div>

                                <div className='d-flex align-items-center'>
                                  <span className={`fw-semibold fs-6 flex-grow-1 pe-3`}>
                                    Kick-start Campaigns
                                  </span>
                                  <span className='fw-bold'>
                                    <i
                                      className={`bi ${
                                        item.kickstartCampaigns
                                          ? 'bi-check text-success'
                                          : 'bi-dash text-danger'
                                      }`}
                                      style={{fontSize: '30px'}}
                                    ></i>
                                  </span>
                                </div>

                                <div className='d-flex align-items-center'>
                                  <span className={`fw-semibold fs-6 flex-grow-1 pe-3`}>
                                    Full Control Campaigns
                                  </span>
                                  <span className='fw-bold'>
                                    <i
                                      className={`bi ${
                                        item.fullControlCampaigns
                                          ? 'bi-check text-success'
                                          : 'bi-dash text-danger'
                                      }`}
                                      style={{fontSize: '30px'}}
                                    ></i>
                                  </span>
                                </div>

                                <div className='d-flex align-items-center'>
                                  <span className={`fw-semibold fs-6 flex-grow-1 pe-3`}>
                                    Embedded Finance
                                  </span>
                                  <span className='fw-bold'>
                                    <i
                                      className={`bi ${
                                        item.embeddedFinance
                                          ? 'bi-check text-success'
                                          : 'bi-dash text-danger'
                                      }`}
                                      style={{fontSize: '30px'}}
                                    ></i>
                                  </span>
                                </div>

                                <div className='d-flex align-items-center'>
                                  <span className={`fw-semibold fs-6 flex-grow-1 pe-3`}>
                                    E-Store
                                  </span>
                                  <span className='fw-bold'>
                                    <i
                                      className={`bi ${
                                        item.eStore
                                          ? 'bi-check text-success'
                                          : 'bi-dash text-danger'
                                      }`}
                                      style={{fontSize: '30px'}}
                                    ></i>
                                  </span>
                                </div>

                                <div className='d-flex align-items-center'>
                                  <span className={`fw-semibold fs-6 flex-grow-1 pe-3`}>
                                    Campaign Recommendations
                                  </span>
                                  <span className='fw-bold'>
                                    <i
                                      className={`bi ${
                                        item.campaignRecommendations
                                          ? 'bi-check text-success'
                                          : 'bi-dash text-danger'
                                      }`}
                                      style={{fontSize: '30px'}}
                                    ></i>
                                  </span>
                                </div>

                                <div className='d-flex align-items-center'>
                                  <span className={`fw-semibold fs-6 flex-grow-1 pe-3`}>
                                    Product Based Recommendations
                                  </span>
                                  <span className='fw-bold'>
                                    <i
                                      className={`bi ${
                                        item.productBasedRecommendations
                                          ? 'bi-check text-success'
                                          : 'bi-dash text-danger'
                                      }`}
                                      style={{fontSize: '30px'}}
                                    ></i>
                                  </span>
                                </div>

                                <div className='d-flex align-items-center'>
                                  <span className={`fw-semibold fs-6 flex-grow-1 pe-3`}>
                                    VIP Program
                                  </span>
                                  <span className='fw-bold'>
                                    <i
                                      className={`bi ${
                                        item.vipProgram
                                          ? 'bi-check text-success'
                                          : 'bi-dash text-danger'
                                      }`}
                                      style={{fontSize: '30px'}}
                                    ></i>
                                  </span>
                                </div>

                                <div className='d-flex align-items-center'>
                                  <span className={`fw-semibold fs-6 flex-grow-1 pe-3`}>
                                    Referral Program
                                  </span>
                                  <span className='fw-bold'>
                                    <i
                                      className={`bi ${
                                        item.referralProgram
                                          ? 'bi-check text-success'
                                          : 'bi-dash text-danger'
                                      }`}
                                      style={{fontSize: '30px'}}
                                    ></i>
                                  </span>
                                </div>

                                <div className='d-flex align-items-center'>
                                  <span className={`fw-semibold fs-6 flex-grow-1 pe-3`}>
                                    Deferred Point Activation
                                  </span>
                                  <span className='fw-bold'>
                                    <i
                                      className={`bi ${
                                        item.deferredPointActivation
                                          ? 'bi-check text-success'
                                          : 'bi-dash text-danger'
                                      }`}
                                      style={{fontSize: '30px'}}
                                    ></i>
                                  </span>
                                </div>

                                <div className='d-flex align-items-center'>
                                  <span className={`fw-semibold fs-6 flex-grow-1 pe-3`}>
                                    Custom Point Activation
                                  </span>
                                  <span className='fw-bold'>
                                    <i
                                      className={`bi ${
                                        item.customPointActivation
                                          ? 'bi-check text-success'
                                          : 'bi-dash text-danger'
                                      }`}
                                      style={{fontSize: '30px'}}
                                    ></i>
                                  </span>
                                </div>

                                <div className='d-flex align-items-center'>
                                  <span className={`fw-semibold fs-6 flex-grow-1 pe-3`}>
                                    Analytics Page
                                  </span>
                                  <span className='fw-bold'>
                                    <i
                                      className={`bi ${
                                        item.analyticPage
                                          ? 'bi-check text-success'
                                          : 'bi-dash text-danger'
                                      }`}
                                      style={{fontSize: '30px'}}
                                    ></i>
                                  </span>
                                </div>

                                <div className='d-flex align-items-center'>
                                  <span className={`fw-semibold fs-6 flex-grow-1 pe-3`}>
                                    Customizable Email Notifications
                                  </span>
                                  <span className='fw-bold'>
                                    <i
                                      className={`bi ${
                                        item.customizableEmailNotifications
                                          ? 'bi-check text-success'
                                          : 'bi-dash text-danger'
                                      }`}
                                      style={{fontSize: '30px'}}
                                    ></i>
                                  </span>
                                </div>

                                <div className='fw-bold fs-5 fst-italic mt-5'>SUPPORT</div>
                                <div className='d-flex align-items-center'>
                                  <span className={`fw-semibold fs-6 flex-grow-1 pe-3`}>
                                    How-to Videos
                                  </span>
                                  <span className='fw-bold'>
                                    <i
                                      className={`bi ${
                                        item.howToVideos
                                          ? 'bi-check text-success'
                                          : 'bi-dash text-danger'
                                      }`}
                                      style={{fontSize: '30px'}}
                                    ></i>
                                  </span>
                                </div>

                                <div className='d-flex align-items-center'>
                                  <span className={`fw-semibold fs-6 flex-grow-1 pe-3`}>
                                    Help Center
                                  </span>
                                  <span className='fw-bold'>
                                    <i
                                      className={`bi ${
                                        item.helpCenter
                                          ? 'bi-check text-success'
                                          : 'bi-dash text-danger'
                                      }`}
                                      style={{fontSize: '30px'}}
                                    ></i>
                                  </span>
                                </div>

                                <div className='d-flex align-items-center'>
                                  <span className={`fw-semibold fs-6 flex-grow-1 pe-3`}>
                                    24/7 Support
                                  </span>
                                  <span className='fw-bold'>
                                    <i
                                      className={`bi ${
                                        item.sevenDaysSupport
                                          ? 'bi-check text-success'
                                          : 'bi-dash text-danger'
                                      }`}
                                      style={{fontSize: '30px'}}
                                    ></i>
                                  </span>
                                </div>

                                <div className='d-flex align-items-center'>
                                  <span className={`fw-semibold fs-6 flex-grow-1 pe-3`}>
                                    Email Support
                                  </span>
                                  <span className='fw-bold'>
                                    <i
                                      className={`bi ${
                                        item.emailSupport
                                          ? 'bi-check text-success'
                                          : 'bi-dash text-danger'
                                      }`}
                                      style={{fontSize: '30px'}}
                                    ></i>
                                  </span>
                                </div>

                                <div className='d-flex align-items-center'>
                                  <span className={`fw-semibold fs-6 flex-grow-1 pe-3`}>
                                    Chatbot Support
                                  </span>
                                  <span className='fw-bold'>
                                    <i
                                      className={`bi ${
                                        item.chatbotSupport
                                          ? 'bi-check text-success'
                                          : 'bi-dash text-danger'
                                      }`}
                                      style={{fontSize: '30px'}}
                                    ></i>
                                  </span>
                                </div>
                              </div>

                              <button
                                className={'btn btn-sm py-5 btn-primary fs-3'}
                                disabled={loadingBtn}
                                onClick={async () => {
                                  setLoadingBtn(true)
                                  changePackage(item.packageID)

                                  const subscriptionResponse = await subscribePlan({
                                    subscriptionID: item.packageID,
                                    merchantID: merchantData.merchantID,
                                  })

                                  if (!subscriptionResponse.status) {
                                    toast.error(
                                      // intl.formatMessage({
                                      //   id: 'AUTH.SUBSCRIPTION.SUBSCRIPTION_FAILED',
                                      // }),
                                      subscriptionResponse.message,
                                      {
                                        position: 'top-right',
                                        autoClose: 5000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: false,
                                        progress: undefined,
                                        theme: 'light',
                                      }
                                    )
                                    setLoadingBtn(false)
                                    return
                                  }

                                  navigate('/become-a-merchant/landing', {
                                    state: {
                                      subscriptionID: item.packageID,
                                      packageDetails: {
                                        packageName: item.packageName,
                                        price: item.price,
                                        discountedPrice: item.discountedPrice,
                                        monthlyTrxFeePerLylTrx: item.monthlyTrxFeePerLylTrx,
                                        pointCouponRedemptionFee: item.pointCouponRedemptionFee,
                                        loyaltyMembersServed: item.loyaltyMembersServed,
                                        portalUser: item.portalUser,
                                        customerSupport: item.customerSupport,
                                        discountEndDate: '02/28/2024',
                                        multiStore: item.multiStore,
                                        sms: item.sms,
                                        email: item.email,
                                        memberLimit: item.memberLimit,
                                        monthlyOrderLimit: item.monthlyOrderLimit,
                                      },
                                    },
                                  })

                                  setLoadingBtn(false)
                                }}
                                style={{
                                  width: '100%',
                                  marginBottom: '4px',
                                }}
                              >
                                <span>
                                  {/* Get Started */}
                                  {intl.formatMessage({id: 'GET_STARTED'})}
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>
                      )
                    })}

                    <div
                      className='col-lg-3 d-none d-lg-block'
                      id='pricingCol'
                      style={{
                        minHeight: '450px !important',
                        height: '100%',
                      }}
                    >
                      <div
                        className='d-flex min-w-400px align-items-center rounded-3 fs-6'
                        ref={packageEnterpriceRef}
                        style={{
                          backgroundColor: '#FFB000',
                          minHeight: packageRef.current?.clientHeight ?? '450px',
                        }}
                      >
                        <div className='d-flex min-w-400px  align-items-start py-3'>
                          <div className='w-100 d-flex flex-column flex-start rounded-3 px-10'>
                            <div className='text-center py-5 w-100'>
                              <h1 className='mb-5 fw-bolder'>
                                {/* Enterprise */}
                                {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.ENTERPRISE'})}
                              </h1>

                              <div className='fw-semibold mb-5'>
                                {/* For large brands seeking complete customization & exclusive support */}
                                {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.ENTERPRISE_DESC'})}
                              </div>

                              <div className='text-center w-100'>
                                <button
                                  className='btn btn-primary w-100'
                                  onClick={() => {
                                    setModal(true)
                                  }}
                                >
                                  {/* Contact us */}
                                  {intl.formatMessage({id: 'CONTACT_US'})}
                                </button>
                              </div>
                            </div>

                            <div
                              className='w-100 py-5'
                              style={{
                                borderTop: '1px solid #571585',
                                borderBottom: '1px solid #571585',
                              }}
                            >
                              <div className='d-flex align-items-start flex-column'>
                                <span className='fw-bold fs-1'>
                                  {/* Custom */}
                                  {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.CUSTOM'})}
                                </span>
                                <span className=''>
                                  {/* Custom order limits */}
                                  {intl.formatMessage({
                                    id: 'AUTH.SUBSCRIPTION.CUSTOM_ORDER_LIMITS',
                                  })}
                                </span>
                              </div>
                            </div>

                            <div className='w-100 py-5'>
                              <div className='d-flex align-items-start flex-column'>
                                <span className='fw-bold'>
                                  {/* Everything in Premium, Plus */}
                                  {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.PREMIUM_PLUS'})}
                                </span>
                                <ul
                                  style={{
                                    listStyleType: 'none',
                                  }}
                                  className='m-0 p-0 mt-2 d-flex flex-column gap-2'
                                >
                                  <li className='d-flex gap-2 align-items-center'>
                                    {/* - No Limits */}
                                    {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.NO_LIMITS'})}
                                  </li>
                                  <li className='d-flex gap-2 align-items-center'>
                                    {/* - All the features */}
                                    {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.ALL_FEATURES'})}
                                  </li>
                                  <li className='d-flex gap-2 align-items-center'>
                                    {/* - Dedicated CMS/Developer support */}
                                    {intl.formatMessage({
                                      id: 'AUTH.SUBSCRIPTION.DEDICATED_SUPPORT',
                                    })}
                                  </li>
                                  <li className='d-flex gap-2 align-items-center'>
                                    {/* - Slack connect channel */}
                                    {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.SLACK_CONNECT'})}
                                  </li>
                                  <li className='d-flex gap-2 align-items-center'>
                                    {/* - Full customization & custom integrations */}
                                    {intl.formatMessage({
                                      id: 'AUTH.SUBSCRIPTION.FULL_CUSTOMIZATION',
                                    })}
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* FIX: RESPONSIVE PRICING */}

                  <div className='mt-6 d-none h-100' id='pricingCol-2'>
                    {packages.map((item, index) => {
                      return (
                        <div className='h-100 w-100' key={index}>
                          <div
                            className={`w-100 d-flex flex-column flex-center rounded-3 py-15 px-10`}
                            style={{
                              backgroundColor: 'rgb(231 231 231)',
                            }}
                          >
                            <div className='mb-7 text-center'>
                              <h1 className={`mb-5 fw-bolder`}>{item.packageName}</h1>

                              <div className='text-center' style={{color: '#141413'}}>
                                <span className='mb-2'>$</span>
                                <span className='fs-3x fw-bold'>{item.discountedPrice}</span>
                              </div>

                              {/*            <div className='text-center'>
                                <span className='mb-2'>$</span>

                                <span
                                  className='fw-bold '
                                  style={{fontSize: '21px'}}
                                  data-kt-plan-price-month='39'
                                  data-kt-plan-price-annual='399'
                                >
                                  {item.discountedPrice}{' '}
                                </span>

                                <span className='fs-7 fw-semibold'>
                                  /
                                  <span data-kt-element='period'>
                                    {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.MON'})}
                                  </span>
                                </span>
                              </div> */}
                            </div>

                            <div className='w-100 mb-10'>
                              <div className='d-flex align-items-center mb-5'>
                                <span className={`fw-semibold fs-6 flex-grow-1 pe-3`}>
                                  {/* Monthly Transaction Limit */}
                                  {intl.formatMessage({
                                    id: 'AUTH.SUBSCRIPTION.LYLTY_MEMBERS_SERVED',
                                  })}
                                </span>
                                <span className='fw-bold fs-4'>{item.loyaltyMembersServed}</span>
                              </div>

                              <div className='d-flex align-items-center mb-5'>
                                <span className={`fw-semibold fs-6 flex-grow-1 pe-3 required`}>
                                  {/* Monthly Transaction Limit */}
                                  {intl.formatMessage({
                                    id: 'AUTH.SUBSCRIPTION.MONTHLY_TRANSACTION',
                                  })}
                                </span>
                                <span className='fw-bold fs-4'>{item.monthlyOrderLimit}</span>
                              </div>

                              <div className='d-flex align-items-center mb-5'>
                                <span className={`fw-semibold fs-6 flex-grow-1 pe-3`}>
                                  {/* Email */}
                                  {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.EmailPm'})}
                                </span>
                                <span className='fw-bold fs-4'>{item.email}</span>
                              </div>

                              <div className='d-flex align-items-center mb-5'>
                                <span className={`fw-semibold fs-6 flex-grow-1 pe-3`}>
                                  {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.SmsPm'})}
                                </span>
                                <span className='fw-bold fs-4'>{item.sms}</span>
                              </div>
                            </div>

                            <button
                              className={'btn btn-sm py-5 bg-primary text-white fs-3'}
                              disabled={loadingBtn}
                              onClick={async () => {
                                setLoadingBtn(true)
                                setSelectedPackage(item)

                                const subscriptionResponse = await subscribePlan({
                                  subscriptionID: item.packageID,
                                  merchantID: merchantData.merchantID,
                                })

                                if (!subscriptionResponse.status) {
                                  toast.error(
                                    // intl.formatMessage({
                                    //   id: 'AUTH.SUBSCRIPTION.SUBSCRIPTION_FAILED',
                                    // }),
                                    subscriptionResponse.message,
                                    {
                                      position: 'top-right',
                                      autoClose: 5000,
                                      hideProgressBar: false,
                                      closeOnClick: true,
                                      pauseOnHover: true,
                                      draggable: false,
                                      progress: undefined,
                                      theme: 'light',
                                    }
                                  )
                                  setLoadingBtn(false)
                                  return
                                }

                                navigate('/become-a-merchant/landing', {
                                  state: {
                                    subscriptionID: item.packageID,
                                    packageDetails: {
                                      packageName: item.packageName,
                                      price: item.price,
                                      discountedPrice: item.discountedPrice,
                                      monthlyTrxFeePerLylTrx: item.monthlyTrxFeePerLylTrx,
                                      pointCouponRedemptionFee: item.pointCouponRedemptionFee,
                                      loyaltyMembersServed: item.loyaltyMembersServed,
                                      portalUser: item.portalUser,
                                      customerSupport: item.customerSupport,
                                      discountEndDate: '02/28/2024',
                                      multiStore: item.multiStore,
                                      sms: item.sms,
                                      email: item.email,
                                      memberLimit: item.memberLimit,
                                      monthlyOrderLimit: item.monthlyOrderLimit,
                                    },
                                  },
                                })
                                setLoadingBtn(false)
                              }}
                              style={{
                                width: '100%',
                              }}
                            >
                              <span>
                                {/* Get Started */}
                                {intl.formatMessage({id: 'GET_STARTED'})}
                              </span>
                            </button>
                          </div>
                        </div>
                      )
                    })}

                    <div
                      className='w-100'
                      style={{
                        minHeight: '450px !important',
                        height: '100%',
                      }}
                    >
                      <div
                        className='d-flex h-100 rounded-3 fs-6 w-100'
                        ref={packageEnterpriceRef2}
                        style={{
                          backgroundColor: '#dffc34',
                          minHeight: packageRef2.current?.clientHeight ?? '450px',
                          height: '100%',
                        }}
                      >
                        <div className='d-flex align-items-center justify-content-center py-3 h-100 w-100'>
                          <div className='w-100 d-flex flex-column flex-start rounded-3 px-10'>
                            <div className='text-center py-5 mb-10 w-100'>
                              <h1 className='mb-5 fw-bolder'>
                                {/* Enterprise */}
                                {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.ENTERPRISE'})}
                              </h1>

                              <div className='fw-semibold mb-5'>
                                {/* For large brands seeking complete customization & exclusive support */}
                                {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.ENTERPRISE_DESC'})}
                              </div>

                              <div className='text-center'>
                                <a
                                  href='#chat'
                                  className='btn w-100'
                                  style={{
                                    backgroundColor: '#343235',
                                    color: 'white',
                                  }}
                                  onClick={() => {
                                    setModal(true)
                                  }}
                                >
                                  {/* Contact us */}
                                  {intl.formatMessage({id: 'CONTACT_US'})}
                                </a>
                              </div>
                            </div>

                            <div
                              className='w-100 py-5 mb-10'
                              style={{
                                borderTop: '1px solid #571585',
                                borderBottom: '1px solid #571585',
                              }}
                            >
                              <div className='d-flex align-items-start flex-column w-100'>
                                <span className='fw-bold fs-1'>
                                  {/* Custom */}
                                  {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.CUSTOM'})}
                                </span>
                                <span className=''>
                                  {/* Custom order limits */}
                                  {intl.formatMessage({
                                    id: 'AUTH.SUBSCRIPTION.CUSTOM_ORDER_LIMITS',
                                  })}
                                </span>
                              </div>
                            </div>

                            <div className='w-100 py-3'>
                              <div className='d-flex align-items-start flex-column'>
                                <span className='fw-bold'>
                                  {/* Everything in Premium, Plus */}
                                  {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.PREMIUM_PLUS'})}
                                </span>
                                <ul
                                  style={{
                                    listStyleType: 'none',
                                  }}
                                  className='m-0 p-0 mt-2 d-flex flex-column gap-2'
                                >
                                  <li className='d-flex gap-2 align-items-center'>
                                    {/* - No Limits */}
                                    {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.NO_LIMITS'})}
                                  </li>
                                  <li className='d-flex gap-2 align-items-center'>
                                    {/* - All the features */}
                                    {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.ALL_FEATURES'})}
                                  </li>
                                  <li className='d-flex gap-2 align-items-center'>
                                    {/* - Dedicated CMS/Developer support */}
                                    {intl.formatMessage({
                                      id: 'AUTH.SUBSCRIPTION.DEDICATED_SUPPORT',
                                    })}
                                  </li>
                                  <li className='d-flex gap-2 align-items-center'>
                                    {/* - Full customization & custom integrations */}
                                    {intl.formatMessage({
                                      id: 'AUTH.SUBSCRIPTION.FULL_CUSTOMIZATION',
                                    })}
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* <div className='mt-10 alert border d-flex flex-column flex-sm-row p-5 mb-10 card card-bordered w-100 w-lg-75'>
                    <div className='d-flex'>
                      <div className='d-flex flex-column pe-0 pe-sm-10'>
                        <h5 className='mb-1 text-primary required'>
                          {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.ADDITIONAL_TRANSACTIONS'})}
                        </h5>

                        <span
                          dangerouslySetInnerHTML={{
                            __html: intl.formatMessage({
                              id: 'AUTH.SUBSCRIPTION.ADDITIONAL_TRANSACTIONS_DESC',
                            }),
                          }}
                        ></span>
                      </div>
                    </div>
                  </div> */}

                  <div className='card mt-10'>
                    <div className='card-header border-0 mb-6'>
                      <h1 className='fs-2x text-primary my-6'>
                        {/* Create, Engage, and Thrive with Campaigns 🚀 */}
                        {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.CREATE_ENGAGE_THRIVE'})}
                      </h1>
                      <div className='fs-5 fw-semibold'>
                        {/* Enhance customer engagement and drive sales with our Campaign Engine. Our
                        easy-to-use platform lets you create and launch promotional campaigns
                        instantly— No technical support is needed! */}
                        {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.CREATE_ENGAGE_THRIVE_DESC'})}
                      </div>
                    </div>
                    <div className='card-body p-5 px-lg-10 py-lg-10 d-flex justify-content-between align-items-start'>
                      {/* DESKTOP CAMPAING TYPES */}
                      <div className='w-100 d-none d-lg-block'>
                        <div className='row g-10 mb-15'>
                          <div className='col-sm-3'>
                            <h3 className='fw-bold text-primary mb-7'>
                              {/* Point Campaigns */}
                              {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.POINT_CAMPAIGNS'})}
                            </h3>
                            <div className='d-flex flex-column fs-4'>
                              <span className='text-black-30 mb-4'>
                                <i className='fa fa-check me-2 text-success'></i>
                                {/* Incremental Points */}
                                {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.INCREMENTAL_POINTS'})}
                              </span>
                              <span className='text-black-30 mb-4'>
                                <i className='fa fa-check me-2 text-success'></i>
                                {/* Fixed Points */}
                                {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.FIXED_POINTS'})}
                              </span>
                              <span className='text-black-30 mb-4'>
                                <i className='fa fa-check me-2 text-success'></i>
                                {/* Percentage Points */}
                                {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.PERCENTAGE_POINTS'})}
                              </span>
                            </div>
                          </div>

                          <div className='col-sm-3'>
                            <h3 className='fw-bold text-primary mb-7'>
                              {/* Discount Campaigns */}
                              {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.DISCOUNT_CAMPAIGNS'})}
                            </h3>
                            <div className='d-flex flex-column fs-4'>
                              <span className='text-black-30 mb-4'>
                                <i className='fa fa-check me-2 text-success'></i>
                                {intl.formatMessage({
                                  id: 'AUTH.SUBSCRIPTION.AMOUNT_OFF_PERCENT_OFF',
                                })}
                                {/* Amount Off or % Off */}
                              </span>
                              {/*  <span className='text-black-30 mb-4'>
                                <i className='fa fa-check me-2 text-success'></i>
                                {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.FIX_PRICE_PER_UNIT'})}
                              </span> */}
                              {/* <span className='text-black-30 mb-4'>
                                <i className='fa fa-check me-2 text-success'></i>
                                {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.BUNDLE_SET_DISCOUNT'})}
                              </span> */}
                              {/*  <span className='text-black-30 mb-4'>
                                <i className='fa fa-check me-2 text-success'></i>
                                {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.BULK_TIERED_DISCOUNT'})}
                              </span> */}
                              <span className='text-black-30 mb-4'>
                                <i className='fa fa-check me-2 text-success'></i>
                                {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.BUY_X_GET_X'})}
                                {/* Buy X Get X */}
                              </span>
                              {/*    <span className='text-black-30 mb-4'>
                                <i className='fa fa-check me-2 text-success'></i>
                                {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.BUY_X_GET_Y_AMOUNT'})}
                              </span> */}
                              <span className='text-black-30 mb-4'>
                                <i className='fa fa-check me-2 text-success'></i>
                                {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.BUY_X_GET_Y_QUANTITY'})}
                                {/* Buy X Get Y (Quantity) */}
                              </span>
                            </div>
                          </div>

                          <div className='col-sm-3'>
                            <h3 className='fw-bold text-primary mb-7'>
                              {/* Coupon Campaigns */}
                              {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.COUPON_CAMPAIGNS'})}
                            </h3>
                            <div className='d-flex flex-column fs-4'>
                              <span className='text-black-30 mb-4'>
                                <i className='fa fa-check me-2 text-success'></i>
                                {/* Amount Off or % Off */}
                                {intl.formatMessage({
                                  id: 'AUTH.SUBSCRIPTION.AMOUNT_OFF_PERCENT_OFF',
                                })}
                              </span>
                              {/* <span className='text-black-30 mb-4'>
                                <i className='fa fa-check me-2 text-success'></i>
                                Fix Price Per Unit
                                {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.FIX_PRICE_PER_UNIT'})}
                              </span> */}
                              {/*  <span className='text-black-30 mb-4'>
                                <i className='fa fa-check me-2 text-success'></i>
                                {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.BUNDLE_SET_DISCOUNT'})}
                              </span> */}
                              {/* <span className='text-black-30 mb-4'>
                                <i className='fa fa-check me-2 text-success'></i>
                                {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.BULK_TIERED_DISCOUNT'})}
                              </span> */}
                              <span className='text-black-30 mb-4'>
                                <i className='fa fa-check me-2 text-success'></i>
                                {/* Buy X Get X */}
                                {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.BUY_X_GET_X'})}
                              </span>
                              {/*  <span className='text-black-30 mb-4'>
                                <i className='fa fa-check me-2 text-success'></i>
                                {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.BUY_X_GET_Y_AMOUNT'})}
                              </span> */}
                              <span className='text-black-30 mb-4'>
                                <i className='fa fa-check me-2 text-success'></i>
                                {/* Buy X Get Y (Quantity) */}
                                {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.BUY_X_GET_Y_QUANTITY'})}
                              </span>
                            </div>
                          </div>

                          <div className='col-sm-3 bg-light p-3 rounded-3 px-7'>
                            <div className='d-flex flex-column'>
                              <p className='text-black-30 fs-4 mb-4'>
                                <b>
                                  {' '}
                                  {/* Power your campaigns with these features to maximize impact, optimize
                              budgets and drive sales. */}
                                  {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.POWER_CAMPAIGNS'})}
                                </b>
                              </p>
                              <div className='d-flex flex-column fs-4'>
                                <p className='text-black-30 mb-4'>
                                  <i className='fa fa-star me-2 text-warning'></i>
                                  {/* Point Activation */}
                                  {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.POINT_ACTIVATION'})}
                                </p>
                                <p className='text-black-30 mb-4'>
                                  <i className='fa fa-star me-2 text-warning'></i>
                                  {/* Point Expiration */}
                                  {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.POINT_EXPIRATION'})}
                                </p>
                                <p className='text-black-30 mb-4'>
                                  <i className='fa fa-star me-2 text-warning'></i>
                                  {/* Most Rewarding Campaign */}
                                  {intl.formatMessage({
                                    id: 'AUTH.SUBSCRIPTION.MOST_REWARDING_CAMPAIGN',
                                  })}
                                </p>
                                <p className='text-black-30 mb-4'>
                                  <i className='fa fa-star me-2 text-warning'></i>
                                  {/* Eligible Products */}
                                  {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.ELIGIBLE_PRODUCTS'})}
                                </p>
                                <p className='text-black-30 mb-4'>
                                  <i className='fa fa-star me-2 text-warning'></i>
                                  {/* Eligible Members */}
                                  {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.ELIGIBLE_MEMBERS'})}
                                </p>
                                <p className='text-black-30 mb-4'>
                                  <i className='fa fa-star me-2 text-warning'></i>
                                  {/* Eligible VIP Tier */}
                                  {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.ELIGIBLE_VIP_TIER'})}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className='row g-10 mb-18'>
                          <div className='col-sm-3'>
                            <h3 className='fw-bold text-primary mb-7'>
                              {/* VIP Campaigns */}
                              {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.REFERRAL_CAMPAIGNS'})}
                            </h3>
                            <div className='d-flex flex-column fw-semibold fs-4'>
                              <div className='d-flex flex-column fs-4'>
                                <span className='text-black-30 mb-4'>
                                  <i className='fa fa-check me-2 text-success'></i>
                                  {/* Fixed Points */}
                                  {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.FIXED_POINTS'})}
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className='col-sm-3'>
                            <h3 className='fw-bold text-primary mb-7'>
                              {/* Birthday Campaigns */}
                              {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.BIRTHDAY_CAMPAIGNS'})}
                            </h3>
                            <div className='d-flex flex-column fw-semibold fs-4'>
                              <div className='d-flex flex-column fs-4'>
                                <span className='text-black-30 mb-4'>
                                  <i className='fa fa-check me-2 text-success'></i>
                                  {/* Fixed Points */}
                                  {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.FIXED_POINTS'})}
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className='col-sm-3'>
                            <h3 className='fw-bold text-primary mb-7'>
                              {/* Sign Up Campaigns */}
                              {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.SIGN_UP_CAMPAIGNS'})}
                            </h3>
                            <div className='d-flex flex-column fw-semibold fs-4'>
                              <div className='d-flex flex-column fs-4'>
                                <span className='text-black-30 mb-4'>
                                  <i className='fa fa-check me-2 text-success'></i>
                                  {/* Fixed Points */}
                                  {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.FIXED_POINTS'})}
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className='col-sm-3'>
                            <h3 className='fw-bold text-primary mb-7'>
                              {/* VIP Campaigns */}
                              {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.VIP_CAMPAIGNS'})}
                            </h3>
                            <div className='d-flex flex-column fw-semibold fs-4'>
                              <div className='d-flex flex-column fs-4'>
                                <span className='text-black-30 mb-4'>
                                  <i className='fa fa-check me-2 text-success'></i>
                                  {/* Birthday Campaigns */}
                                  {intl.formatMessage({id: 'CAMPAIGN.POINT.FIXED'})}
                                </span>
                                <span className='text-black-30 mb-4'>
                                  <i className='fa fa-check me-2 text-success'></i>
                                  {/* Discount Campaigns */}
                                  {intl.formatMessage({id: 'DISCOUNT.AMOUNT_OFF_PERCENT_OFF'})}
                                </span>
                                <span className='text-black-30 mb-4'>
                                  <i className='fa fa-check me-2 text-success'></i>
                                  {/* Point Campaigns */}
                                  {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.BIRTHDAY_CAMPAIGNS'})}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* TABLET CAMPAIGN TYPES */}
                      <div className='w-100 d-block d-lg-none'>
                        <div className='row g-10 mb-15'>
                          <div className='col-lg-12 bg-light p-3 rounded-3 px-7'>
                            <div className='d-flex flex-column'>
                              <p className='text-black-30 fs-4 mb-4'>
                                <b>
                                  {' '}
                                  {/* Power your campaigns with these features to maximize impact, optimize
                              budgets and drive sales. */}
                                  {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.POWER_CAMPAIGNS'})}
                                </b>
                              </p>
                              <div className='d-flex flex-column fs-4'>
                                <p className='text-black-30 mb-4'>
                                  <i className='fa fa-star me-2 text-warning'></i>
                                  {/* Point Activation */}
                                  {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.POINT_ACTIVATION'})}
                                </p>
                                <p className='text-black-30 mb-4'>
                                  <i className='fa fa-star me-2 text-warning'></i>
                                  {/* Point Expiration */}
                                  {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.POINT_EXPIRATION'})}
                                </p>
                                <p className='text-black-30 mb-4'>
                                  <i className='fa fa-star me-2 text-warning'></i>
                                  {/* Most Rewarding Campaign */}
                                  {intl.formatMessage({
                                    id: 'AUTH.SUBSCRIPTION.MOST_REWARDING_CAMPAIGN',
                                  })}
                                </p>
                                <p className='text-black-30 mb-4'>
                                  <i className='fa fa-star me-2 text-warning'></i>
                                  {/* Eligible Products */}
                                  {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.ELIGIBLE_PRODUCTS'})}
                                </p>
                                <p className='text-black-30 mb-4'>
                                  <i className='fa fa-star me-2 text-warning'></i>
                                  {/* Eligible Members */}
                                  {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.ELIGIBLE_MEMBERS'})}
                                </p>
                                <p className='text-black-30 mb-4'>
                                  <i className='fa fa-star me-2 text-warning'></i>
                                  {/* Eligible VIP Tier */}
                                  {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.ELIGIBLE_VIP_TIER'})}
                                </p>
                              </div>
                            </div>
                          </div>

                          <div className='col-lg-6'>
                            <h3 className='fw-bold text-primary mb-7'>
                              {/* Point Campaigns */}
                              {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.POINT_CAMPAIGNS'})}
                            </h3>
                            <div className='d-flex flex-column fs-4'>
                              <span className='text-black-30 mb-4'>
                                <i className='fa fa-check me-2 text-success'></i>
                                {/* Incremental Points */}
                                {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.INCREMENTAL_POINTS'})}
                              </span>
                              <span className='text-black-30 mb-4'>
                                <i className='fa fa-check me-2 text-success'></i>
                                {/* Fixed Points */}
                                {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.FIXED_POINTS'})}
                              </span>
                              <span className='text-black-30 mb-4'>
                                <i className='fa fa-check me-2 text-success'></i>
                                {/* Percentage Points */}
                                {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.PERCENTAGE_POINTS'})}
                              </span>
                            </div>
                          </div>

                          <div className='col-lg-6'>
                            <h3 className='fw-bold text-primary mb-7'>
                              {/* Discount Campaigns */}
                              {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.DISCOUNT_CAMPAIGNS'})}
                            </h3>
                            <div className='d-flex flex-column fs-4'>
                              <span className='text-black-30 mb-4'>
                                <i className='fa fa-check me-2 text-success'></i>
                                {intl.formatMessage({
                                  id: 'AUTH.SUBSCRIPTION.AMOUNT_OFF_PERCENT_OFF',
                                })}
                                {/* Amount Off or % Off */}
                              </span>
                              {/*   <span className='text-black-30 mb-4'>
                                <i className='fa fa-check me-2 text-success'></i>
                                {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.FIX_PRICE_PER_UNIT'})}
                              </span> */}
                              {/*  <span className='text-black-30 mb-4'>
                                <i className='fa fa-check me-2 text-success'></i>
                                {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.BUNDLE_SET_DISCOUNT'})}
                              </span> */}
                              {/* <span className='text-black-30 mb-4'>
                                <i className='fa fa-check me-2 text-success'></i>
                                {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.BULK_TIERED_DISCOUNT'})}
                              </span> */}
                              <span className='text-black-30 mb-4'>
                                <i className='fa fa-check me-2 text-success'></i>
                                {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.BUY_X_GET_X'})}
                                {/* Buy X Get X */}
                              </span>
                              {/*    <span className='text-black-30 mb-4'>
                                <i className='fa fa-check me-2 text-success'></i>
                                {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.BUY_X_GET_Y_AMOUNT'})}
                              </span> */}
                              <span className='text-black-30 mb-4'>
                                <i className='fa fa-check me-2 text-success'></i>
                                {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.BUY_X_GET_Y_QUANTITY'})}
                                {/* Buy X Get Y (Quantity) */}
                              </span>
                            </div>
                          </div>

                          <div className='col-lg-6'>
                            <h3 className='fw-bold text-primary mb-7'>
                              {/* Coupon Campaigns */}
                              {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.COUPON_CAMPAIGNS'})}
                            </h3>
                            <div className='d-flex flex-column fs-4'>
                              <span className='text-black-30 mb-4'>
                                <i className='fa fa-check me-2 text-success'></i>
                                {/* Amount Off or % Off */}
                                {intl.formatMessage({
                                  id: 'AUTH.SUBSCRIPTION.AMOUNT_OFF_PERCENT_OFF',
                                })}
                              </span>
                              {/* <span className='text-black-30 mb-4'>
                                <i className='fa fa-check me-2 text-success'></i>
                                Fix Price Per Unit
                                {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.FIX_PRICE_PER_UNIT'})}
                              </span> */}
                              {/*  <span className='text-black-30 mb-4'>
                                <i className='fa fa-check me-2 text-success'></i>
                                {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.BUNDLE_SET_DISCOUNT'})}
                              </span> */}
                              {/* <span className='text-black-30 mb-4'>
                                <i className='fa fa-check me-2 text-success'></i>
                                {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.BULK_TIERED_DISCOUNT'})}
                              </span> */}
                              <span className='text-black-30 mb-4'>
                                <i className='fa fa-check me-2 text-success'></i>
                                {/* Buy X Get X */}
                                {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.BUY_X_GET_X'})}
                              </span>
                              {/* <span className='text-black-30 mb-4'>
                                <i className='fa fa-check me-2 text-success'></i>
                                {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.BUY_X_GET_Y_AMOUNT'})}
                              </span> */}
                              <span className='text-black-30 mb-4'>
                                <i className='fa fa-check me-2 text-success'></i>
                                {/* Buy X Get Y (Quantity) */}
                                {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.BUY_X_GET_Y_QUANTITY'})}
                              </span>
                            </div>
                          </div>

                          <div className='col-lg-6'>
                            <h3 className='fw-bold text-primary mb-7'>
                              {/* VIP Campaigns */}
                              {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.REFERRAL_CAMPAIGNS'})}
                            </h3>
                            <div className='d-flex flex-column fw-semibold fs-4'>
                              <div className='d-flex flex-column fs-4'>
                                <span className='text-black-30 mb-4'>
                                  <i className='fa fa-check me-2 text-success'></i>
                                  {/* Fixed Points */}
                                  {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.FIXED_POINTS'})}
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className='col-lg-6'>
                            <h3 className='fw-bold text-primary mb-7'>
                              {/* Birthday Campaigns */}
                              {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.BIRTHDAY_CAMPAIGNS'})}
                            </h3>
                            <div className='d-flex flex-column fw-semibold fs-4'>
                              <div className='d-flex flex-column fs-4'>
                                <span className='text-black-30 mb-4'>
                                  <i className='fa fa-check me-2 text-success'></i>
                                  {/* Fixed Points */}
                                  {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.FIXED_POINTS'})}
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className='col-lg-6'>
                            <h3 className='fw-bold text-primary mb-7'>
                              {/* Sign Up Campaigns */}
                              {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.SIGN_UP_CAMPAIGNS'})}
                            </h3>
                            <div className='d-flex flex-column fw-semibold fs-4'>
                              <div className='d-flex flex-column fs-4'>
                                <span className='text-black-30 mb-4'>
                                  <i className='fa fa-check me-2 text-success'></i>
                                  {/* Fixed Points */}
                                  {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.FIXED_POINTS'})}
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className='col-lg-6'>
                            <h3 className='fw-bold text-primary mb-7'>
                              {/* VIP Campaigns */}
                              {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.VIP_CAMPAIGNS'})}
                            </h3>
                            <div className='d-flex flex-column fw-semibold fs-4'>
                              <div className='d-flex flex-column fs-4'>
                                <span className='text-black-30 mb-4'>
                                  <i className='fa fa-check me-2 text-success'></i>
                                  {/* Birthday Campaigns */}
                                  {intl.formatMessage({id: 'CAMPAIGN.POINT.FIXED'})}
                                </span>
                                <span className='text-black-30 mb-4'>
                                  <i className='fa fa-check me-2 text-success'></i>
                                  {/* Discount Campaigns */}
                                  {intl.formatMessage({id: 'DISCOUNT.AMOUNT_OFF_PERCENT_OFF'})}
                                </span>
                                <span className='text-black-30 mb-4'>
                                  <i className='fa fa-check me-2 text-success'></i>
                                  {/* Point Campaigns */}
                                  {intl.formatMessage({id: 'AUTH.SUBSCRIPTION.BIRTHDAY_CAMPAIGNS'})}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  )
}
